import { Component, OnInit, ViewChild } from '@angular/core';
import { EmployeeInviteListComponent } from '../invite-list/employee-invite-list.component';

@Component({
  selector: 'app-employee-summary',
  templateUrl: './employee-summary.component.html',
  styleUrls: ['./employee-summary.component.scss'],
  standalone: false,
})
export class EmployeeSummaryComponent implements OnInit {

  @ViewChild('invitationList')
  employeeInviteListComponent: EmployeeInviteListComponent;

  ngOnInit(): void {
  }

  async onInviteSent(event) {
    await this.employeeInviteListComponent.refresh();
  }

}
